import { render, staticRenderFns } from "./m-addShortAnswerChild.vue?vue&type=template&id=f97aca02&"
import script from "./m-addShortAnswerChild.vue?vue&type=script&lang=js&"
export * from "./m-addShortAnswerChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports